<template>
    <div>
        <el-dialog
            class="invoice"
            :title="title"
            :visible.sync="dialogVisible"
            :before-close="cancelDialog"
            width="36%"
        >
            <el-form
                :model="courier"
                :rules="rules"
                ref="ruleForm"
                label-width="160px"
                class="invoice-rule"
            >
                <el-form-item label="快递公司" prop="courierCompany">
                    <el-select v-model="courier.courierCompany" placeholder="快递公司" style="width:100%">
                        <el-option
                        v-for="item in courierCompanys"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="快递单号" prop="courierNo">
                    <el-input
                        v-model="courier.courierNo"
                        @blur="inputNum(courier.courierNo)"
                        placeholder="请输入快递单号" ></el-input>
                </el-form-item>

            </el-form>

            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="playVideo">发票销货清单折叠要求</el-button>
                <el-button type="primary" @click="submitForm">发票寄出</el-button>
            </div>
        </el-dialog>
        <el-dialog
            title="视频预览"
            :visible.sync="dialogPlay"
            width="30%"
            @close="closeDialog"
        >
            <video
                :src="videoUrl"
                controls
                autoplay
                ref="dialogVideo"
                width="100%"
            ></video>
        </el-dialog>
    </div>
</template>

<script>

import Picture from '../../../../components/dialog/Picture';
import invoiceUpload from '../components/Upload';
import common from '@/modules/transport/bms/common/common';
import { getControlParam } from '../../../../api/common';
const { initSessionData } = common;
export default {
    // eslint-disable-next-line vue/no-unused-components
    components: { invoiceUpload, Picture },
    props: {
        dialogVisible: {
            type: Boolean,
            default: false
        },
        title: {
            type: String
        },
        apApply: {
            type: Object,
            required: true,
            // eslint-disable-next-line vue/require-valid-default-prop
            default: {}
        }
    },
    data() {
        return {
            courierCompanys: [],
            courier: {
                courierCompany: undefined,
                courierNo: undefined
            },
            rules: {
                courierCompany: [
                    {
                        required: true,
                        message: '请选择快递公司'
                    }
                ],
                courierNo: [
                    {
                        required: true,
                        message: '快递单号不能为空',
                        trigger: ['blur', 'change']
                    }
                ]
            },
            // 视频播放
            dialogPlay: false,
            videoUrl: '',
            invoiceVideoUrl: ''
        };
    },
    methods: {
        inputNum(deliveryNo) {
            this.deliveryNo = deliveryNo.replace(/[^\w\.\/]/ig, '');
        },
        cancelDialog() {
            this.$emit('cancelDialog', '');
        },
        submitForm() {
            this.$confirm('请确认发票已按照要求整理，否则会退回发票！', '提示', {
                confirmButtonText: '是',
                cancelButtonText: '否',
                type: 'warning'
            }).then(() => {
                this.$refs['ruleForm'].validate(valid => {
                    if (valid) {
                        this.$emit('saveFrom', this.courier);
                    } else {
                        return false;
                    }
                });
            }).catch(() => {
                this.$message({
                    message: '已取消寄出'
                });
            });
        },
        // 视频
        playVideo() {
            this.dialogPlay = true;
            this.videoUrl = this.invoiceVideoUrl;
        },
        closeDialog() {
            this.videoUrl = ''; // 清空数据 关闭视频播放
        },
        getInvoiceVideoUrl() {
            // 获取视频
            const formData = new FormData();
            formData.append('controlParam', 'BMS_INVOICE_LIST_ORGANIZATION_VIDEO_URL');
            getControlParam(formData).then(res => {
                if (res && res.code === '0') {
                    this.invoiceVideoUrl = res.data.value;
                } else {
                    this.$message({
                        message: '未配置BMS_INVOICE_LIST_ORGANIZATION_VIDEO_URL系统控制参数，或者获取失败'
                    });
                }
            });
        }
    },
    async  mounted() {
        this.getInvoiceVideoUrl();
        await initSessionData(['SYS_BMS_EXPRESS_COMPANY']);
        const { SYS_BMS_EXPRESS_COMPANY } = window.sessionStorage;
        const expressCompany = JSON.parse(SYS_BMS_EXPRESS_COMPANY);
        // eslint-disable-next-line guard-for-in
        for (var key in expressCompany) {
            this.courierCompanys.push({
                value: key,
                label: expressCompany[key]
            });
        }
    }
};
</script>

<style lang="less">
.invoice {
    .invoice-rule {
        .el-input {
            width: 80%;
        }
    }
    .dialog-footer {
        display: flex;
        justify-content: space-around;
    }
    .upload-item {
        position: relative;
        .upload-item-icon {
            width: 80%;
            height: 28px;
            font-size: 16px;
            color: #33c9cc;
            position: absolute;
            top: 2px;
        }
        .upload-demo {
            width: 100%;
            height: 28px;
        }
    }
    .el-upload {
        width: 100%;
        height: 28px;
        text-align: right;
    }
    .upload_icon {
        width: 100%;
        height: 23px;
        box-sizing: border-box;
        padding-right: 8px;
    }
    .bank-upload {
        margin-left: 16px;
    }
}
</style>
